export default __webpack_public_path__ + "static/media/quotes.5c85a087.svg";